module.exports = __webpack_public_path__ + "img/ifunny.c54f8ffb.png";